import React, { useState } from 'react';
import { FaLightbulb, FaBuilding, FaWater, FaSwimmingPool, FaDumbbell, FaFileDownload } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';

const AmenitiesSection = ({ PropertyFeatures = {},brochure }) => {
  const [showAll, setShowAll] = useState(false);
  
  const categorizedFeatures = [
    { title: 'Amenities', items: PropertyFeatures.amenities || [] },
    { title: 'Features', items: PropertyFeatures.features || [] },
    { title: 'Additional Features', items: PropertyFeatures.additionalFeatures || [] },
    { title: 'Other Features', items: PropertyFeatures.otherFeatues || [] },
    { title: 'Location Advantages', items: PropertyFeatures.locationAdvantageFeatures || [] }
  ];

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      {/* Header Section */}
      <h2 className="text-[24px] font-semibold text-[#303030] mb-6">Amenities & Features</h2>

      {/* Features Grid */}
      {categorizedFeatures.map((category, index) => (
        category.items.length > 0 && (
          <div key={index} className="mb-4">
            <h3 className="text-[20px] font-medium text-[#303030] mb-2">{category.title}</h3>
            <div className="grid grid-cols-3 gap-y-4 text-gray-800 text-sm">
              {category.items.slice(0, showAll ? category.items.length : 3).map((item, idx) => (
                <div key={idx} className="flex items-center space-x-2">
                  <FaBuilding className="text-gray-700 text-[20px]" />
                  <span className="text-[#303030] text-[16px] font-normal">{item}</span>
                </div>
              ))}
            </div>
          </div>
        )
      ))}

      {/* Links Section */}
      <div className="flex space-x-8 items-center mt-6">
        {categorizedFeatures.some(category => category.items.length > 3) && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-[#d8232a] text-base underline font-semibold hover:underline flex items-end"
          >
            {showAll ? 'View Less Features' : 'View All Features'} <IoIosArrowDown className='text-[18px]'/>
          </button>
        )}

       {brochure && <a href="#" className="flex items-center space-x-2 text-[#303030] text-base font-medium hover:text-gray-700">
          <FaFileDownload className="text-gray-800 text-[20px]" />
          <span className='underline'>Download Brochure</span>
        </a>}
      </div>
    </div>
  );
};

export default AmenitiesSection;
